"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var InputOptionStore = /** @class */ (function () {
    function InputOptionStore(props) {
        this.value = String(props.value); // NOTE: APIから数字できてしまうことも考慮して明示的にキャスト
        this.label = props.label;
        this.description = props.description;
        this.importCategoryId = props.importCategoryId;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], InputOptionStore.prototype, "value", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], InputOptionStore.prototype, "label", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], InputOptionStore.prototype, "importCategoryId", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], InputOptionStore.prototype, "description", void 0);
    return InputOptionStore;
}());
exports.default = InputOptionStore;
